import { GameModelEvent } from "@nolimitcity/slot-game/bin/model/GameModel";

import { EventsManager, GameEvents, ReelsEvents } from "../../../abstracts/events/EventsManager";
import { AbstractModuleController } from "../../../abstracts/modules/AbstractModuleController";
import { ColorSet, log } from "../../../abstracts/utils/AbstractConsole";
import { UgliestCatch } from "../../UgliestCatch";
import { UCReelsView } from "./UCReelsView";

export class UCReelsController extends AbstractModuleController {
    public get name(): string {
        return `UCReelsController`;
    }

    public get view(): UCReelsView {
        if (this._view === undefined || this._view === null) {
            this._view = new UCReelsView();
        }
        return this._view as UCReelsView;
    }

    protected handleEvents(): void {
        super.handleEvents();

        EventsManager.trigger(ReelsEvents.GET_REELS_VIEW, this.view);

        EventsManager.trigger(ReelsEvents.GET_REELS, this.view.getReels());

        UgliestCatch.model.events?.on(GameModelEvent.GAME, () => {
            this.generateNextReels();
        });

        EventsManager.on(GameEvents.SHOW_XBET_FRAME, () => {
            this.view.showXBetFrame();
        });

        EventsManager.on(GameEvents.HIDE_XBET_FRAME, () => {
            this.view.hideXBetFrame();
        });
    }

    protected handleView(): void {
        super.handleView();

        let currentReels: string[][] = Object.assign([], UgliestCatch.model.data.reels);

        this.view.generateInitialReels(currentReels);
    }

    protected generateNextReels(): void {
        log(`setNextReels | currentMode: ${UgliestCatch.model.gameData.mode} `, ColorSet.YELLOW);

        const updatedSymbols: string[][] = Object.assign([], UgliestCatch.model.data.reels);

        updatedSymbols.forEach((reel, reelIndex) => {
            reel.forEach((symbol, symbolIndex) => {
                if (symbol === `M4`) {
                    const symbolName: string =
                        UgliestCatch.model.gameData.evaluatedArea[reelIndex][symbolIndex];
                    reel[symbolIndex] = symbolName;
                }
            });
        });

        UgliestCatch.model.currentSymbols = updatedSymbols;
    }
}
